module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row4_havefun.ba210a80.png";